/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Wrapper_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Speaker management" |
*
* @param {Speakers_Wrapper_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_wrapper_aria_label = /** @type {((inputs?: Speakers_Wrapper_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Wrapper_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gestion des intervenants")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprechermanagement")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestione degli altoparlanti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("управление спикерами")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gestión de oradores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("演讲者管理")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカー管理")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वक्ता प्रबंधन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gestão de palestrantes")
	return /** @type {LocalizedString} */ ("Speaker management")
});